const storageKey = Object.freeze({
  user: "PPN_user",
  cart: "PPN_cart",
  category: "PPN_category",
  theme: "PPN_theme",
  pageLimit: "pageLimit",
  requestQuote: "PPN_requestQuote",
  sortOrder: "PPN_sortOrder",
  recentlyViewed: "PPN_recentlyViewedProducts",
  /** Set in sessionStorage only after a quote request is submitted successfully; thank-you route reads this. */
  quoteThankYouGate: "PPN_quoteThankYouGate",
  /** JSON string[] of recent catalogue search queries (header search). */
  recentSearchQueries: "PPN_recentSearchQueries",
});

type storageKey = keyof typeof storageKey;

export { storageKey };
